import {Action} from '@ngrx/store';

export const GET_ALL_SHIFTS = '[Shifts] Get All';
export const GET_ALL_SHIFTS_SUCCESS = '[Shifts] Get All Success';
export const GET_ALL_SHIFTS_ERROR = '[Shifts] Get All Error';

export const GET_SHIFT = '[Shifts] Get Shift';
export const GET_SHIFT_SUCCESS = '[Shifts] Get Shift Success';
export const GET_SHIFT_ERROR = '[Shifts] Get Shift Error';

export const ROTATE_SHIFT = '[Shifts] Rotate Shift';
export const ROTATE_SHIFT_SUCCESS = '[Shifts] Rotate Shift Success';
export const ROTATE_SHIFT_ERROR = '[Shifts] Rotate Shift Error';

export class GetAllShifts implements Action {
  readonly type = GET_ALL_SHIFTS;
}

export class GetAllShiftsSuccess implements Action {
  readonly type = GET_ALL_SHIFTS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllShiftsError implements Action {
  readonly type = GET_ALL_SHIFTS_ERROR;

  constructor(public payload: any) {
  }
}

export class GetShift implements Action {
  readonly type = GET_SHIFT;

  constructor(public payload: any) {
  }
}

export class GetShiftSuccess implements Action {
  readonly type = GET_SHIFT_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetShiftError implements Action {
  readonly type = GET_SHIFT_ERROR;

  constructor(public payload: any) {
  }
}

export class RotateShift implements Action {
  readonly type = ROTATE_SHIFT;

  constructor(public payload: any) {
  }
}

export class RotateShiftSuccess implements Action {
  readonly type = ROTATE_SHIFT_SUCCESS;

  constructor(public payload: any) {
  }
}

export class RotateShiftError implements Action {
  readonly type = ROTATE_SHIFT_ERROR;

  constructor(public payload: any) {
  }
}

export type ShiftAction =
  GetAllShifts
  | GetAllShiftsSuccess
  | GetAllShiftsError
  | GetShift
  | GetShiftError
  | GetShiftSuccess
  | RotateShift
  | RotateShiftSuccess
  | RotateShiftError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shifts/store/actions/shift.action.ts